import { useTranslation } from 'react-i18next';

import { Trigger } from 'models/automation/Triggers';

interface ActionTypeCellProps {
  getValue: () => Trigger['actionType'];
}

const ActionTypeCell = ({ getValue }: ActionTypeCellProps) => {
  const { t } = useTranslation();
  const actionType = getValue();

  if (!actionType) {
    return '';
  }

  return t('pageAutomations.triggers.actionType', { context: actionType });
};

export default ActionTypeCell;
